import { db } from "../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { danhMucApi } from "./danhMuc";
import { giaTheoNgayApi } from "./giaTheoNgay";

const DOC_CAU_HINH = doc(db, "caiDat", "giaBoWebsite");
const DOC_CONG_KHAI = doc(db, "congKhai", "giaBo");

/** URL push mặc định (production) — secret không hardcode, nhập ở Cài đặt. */
export const GIA_BO_PUSH_URL_MAC_DINH = "https://lvnongnghiep.com/wp-json/gia-bo/v1/push";

function pad2(n) {
  return String(n).padStart(2, "0");
}

function ngayHomNay() {
  const ms = Date.now() + 7 * 60 * 60 * 1000;
  const d = new Date(ms);
  return `${d.getUTCFullYear()}-${pad2(d.getUTCMonth() + 1)}-${pad2(d.getUTCDate())}`;
}

function ngayCong(ngayStr, soNgay) {
  const d = new Date(`${ngayStr}T00:00:00`);
  d.setDate(d.getDate() + soNgay);
  return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
}

function ngayLabelVN(ngayStr) {
  const [y, m, day] = String(ngayStr).split("-");
  if (!y || !m || !day) return ngayStr;
  return `${day}/${m}/${y}`;
}

/**
 * URL WordPress kéo giá (Firestore REST, field body = JSON chuẩn).
 * Kèm API key web (đã public trong bundle CRA) để Google API chấp nhận request.
 */
export function urlKeoGiaCongKhai() {
  const projectId = process.env.REACT_APP_FIREBASE_PROJECT_ID || "lv-thumua";
  const key = process.env.REACT_APP_FIREBASE_API_KEY || "";
  const base = `https://firestore.googleapis.com/v1/projects/${projectId}/databases/(default)/documents/congKhai/giaBo`;
  return key ? `${base}?key=${encodeURIComponent(key)}` : base;
}

function healthUrlTuPush(pushUrl) {
  const raw = String(pushUrl ?? "").trim();
  if (!raw) return "";
  try {
    const u = new URL(raw);
    u.pathname = u.pathname.replace(/\/push\/?$/, "/health");
    if (!u.pathname.includes("/health")) {
      u.pathname = "/wp-json/gia-bo/v1/health";
    }
    return u.toString();
  } catch {
    return "";
  }
}

async function xayPayload({ denNgay } = {}) {
  const den = denNgay || ngayHomNay();
  const dsLoai = await danhMucApi.loaiBo();
  const tenTheoId = Object.fromEntries(dsLoai.map((lb) => [lb.id, lb.tenLoai]));

  const history = [];
  for (let i = 6; i >= 0; i -= 1) {
    const ngay = ngayCong(den, -i);
    const dsGia = await giaTheoNgayApi.layTheoNgay(ngay);
    const items = dsGia
      .filter((g) => g.donGia != null && Number(g.donGia) > 0)
      .map((g) => ({
        product: tenTheoId[g.maLoaiBo] || g.maLoaiBo,
        price: Number(g.donGia),
        unit: "VND/kg",
        date: ngayLabelVN(ngay),
      }))
      .filter((it) => it.product);
    history.push({ date: ngayLabelVN(ngay), ngay: ngayLabelVN(ngay), items });
  }

  const today = history[history.length - 1];
  return {
    updated_at: new Date().toISOString(),
    date: today.date,
    currency: "VND",
    items: today.items,
    history,
  };
}

export const giaBoWebsiteApi = {
  urlKeoGiaCongKhai,

  async layCauHinh() {
    const snap = await getDoc(DOC_CAU_HINH);
    const data = snap.exists() ? snap.data() : {};
    return {
      pushUrl: data.pushUrl || GIA_BO_PUSH_URL_MAC_DINH,
      secret: data.secret || "",
      tuDongDay: data.tuDongDay !== false,
      pullUrl: data.pullUrl || urlKeoGiaCongKhai(),
      capNhatLuc: data.capNhatLuc || null,
      lanDayCuoi: data.lanDayCuoi || null,
    };
  },

  async luuCauHinh({ pushUrl, secret, tuDongDay }) {
    const url = String(pushUrl ?? "").trim() || GIA_BO_PUSH_URL_MAC_DINH;
    const sec = String(secret ?? "").trim();
    const data = {
      pushUrl: url,
      secret: sec,
      tuDongDay: tuDongDay !== false,
      pullUrl: urlKeoGiaCongKhai(),
      capNhatLuc: new Date().toISOString(),
    };
    await setDoc(DOC_CAU_HINH, data, { merge: true });
    return data;
  },

  async kiemTraHealth(pushUrl) {
    const healthUrl = healthUrlTuPush(pushUrl || GIA_BO_PUSH_URL_MAC_DINH);
    if (!healthUrl) throw new Error("URL push không hợp lệ.");
    const res = await fetch(healthUrl, { method: "GET", headers: { Accept: "application/json" } });
    const body = await res.json().catch(() => ({}));
    if (!res.ok || !body.ok) {
      throw new Error(`Health thất bại: HTTP ${res.status} ${JSON.stringify(body)}`);
    }
    return body;
  },

  /**
   * Xuất JSON công khai — WordPress kéo qua Firestore REST (field body).
   * Luôn tạo document (kể cả chưa có giá) để URL không còn 404.
   */
  async xuatBanCongKhai({ ngay } = {}) {
    const den = ngay || ngayHomNay();
    const payload = await xayPayload({ denNgay: den });

    await setDoc(DOC_CONG_KHAI, {
      body: JSON.stringify(payload),
      updated_at: payload.updated_at,
      date: payload.date,
      source: "thumua-app",
    });

    const pullUrl = urlKeoGiaCongKhai();
    const soLoai = payload.items.length;
    try {
      await setDoc(
        DOC_CAU_HINH,
        {
          pullUrl,
          lanDayCuoi: {
            luc: new Date().toISOString(),
            ngay: den,
            ok: true,
            message:
              soLoai > 0
                ? `Đã xuất bản JSON công khai (${soLoai} loại hôm nay).`
                : "Đã tạo URL công khai (chưa có giá hôm nay — WP Sync sẽ không còn 404).",
            saved_count: soLoai,
            pullUrl,
          },
        },
        { merge: true }
      );
    } catch {
      // BGD có thể không ghi caiDat.
    }

    return { pullUrl, payload };
  },

  /**
   * Đồng bộ: xuất JSON công khai + đẩy WP nếu đã có secret.
   * Ưu tiên push (ổn định); pull chỉ còn dự phòng/cron.
   */
  async dayGiaLenWebsite({ ngay, cauHinh }) {
    if (!ngay) throw new Error("Thiếu ngày để đẩy giá.");

    const cfg = cauHinh || (await this.layCauHinh());
    const { pullUrl, payload } = await this.xuatBanCongKhai({ ngay });

    const pushUrl = String(cfg.pushUrl ?? "").trim() || GIA_BO_PUSH_URL_MAC_DINH;
    const secret = String(cfg.secret ?? "").trim();

    const dsLoai = await danhMucApi.loaiBo();
    const tenTheoId = Object.fromEntries(dsLoai.map((lb) => [lb.id, lb.tenLoai]));
    const dsGiaNgay = await giaTheoNgayApi.layTheoNgay(ngay);
    const items = dsGiaNgay
      .filter((g) => g.donGia != null && Number(g.donGia) > 0)
      .map((g) => ({
        product: tenTheoId[g.maLoaiBo] || g.maLoaiBo,
        price: Number(g.donGia),
        unit: "VND/kg",
      }))
      .filter((it) => it.product);

    if (!secret) {
      return {
        success: true,
        message:
          items.length > 0
            ? `Đã xuất bản JSON công khai (${items.length} loại). Chưa có secret — Admin dán X-Gia-Bo-Secret ở Cài đặt rồi bấm Đồng bộ lại để đẩy thẳng lên web.`
            : "Đã tạo URL công khai (hết 404). Chưa có giá ngày này và chưa có secret để đẩy WP.",
        pullUrl,
        saved_count: items.length,
        pushed: false,
      };
    }

    if (items.length === 0) {
      return {
        success: true,
        message: `Đã xuất bản JSON (hết 404). Ngày ${ngay} chưa có giá — không đẩy WP.`,
        pullUrl,
        pushed: false,
      };
    }

    // Đẩy đủ history 7 ngày nếu có — plugin nhận history.
    const bodyPush = {
      updated_at: payload.updated_at,
      history: payload.history.filter((h) => (h.items || []).length > 0),
    };
    if (bodyPush.history.length === 0) {
      bodyPush.date = ngay;
      bodyPush.items = items;
      delete bodyPush.history;
    }

    const res = await fetch(pushUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "X-Gia-Bo-Secret": secret,
      },
      body: JSON.stringify(bodyPush),
    });

    const body = await res.json().catch(() => ({}));
    if (!res.ok || !body.success) {
      const msg =
        (typeof body.message === "string" && body.message) ||
        (typeof body.code === "string" && body.code) ||
        JSON.stringify(body);
      throw new Error(`Đẩy WP thất bại: HTTP ${res.status} ${msg}`);
    }

    const lanDayCuoi = {
      luc: new Date().toISOString(),
      ngay,
      ok: true,
      message: body.message || `Đã đẩy ${body.saved_count ?? items.length} loại lên website.`,
      saved_count: body.saved_count ?? items.length,
      pullUrl,
    };
    try {
      await setDoc(DOC_CAU_HINH, { lanDayCuoi, pullUrl, secret, pushUrl }, { merge: true });
    } catch {
      // ignore
    }

    return { ...body, lanDayCuoi, pullUrl, pushed: true };
  },
};
